import React from 'react'

const SvgHealthSystemOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M20 4.033v1.383A5.017 5.017 0 0122 7V4.033c0-1.322-.653-1.988-1.96-1.998-8.563-.068-13.757-.02-15.583-.002L4 2.037c-1.333.01-2 .674-2 1.996V16.01c0 1.332.671 1.997 2.014 1.997H9l-1 1.997H7c-.667 0-1 .332-1 .998 0 .665.333.998 1 .998h8a5.018 5.018 0 01-1.582-1.996H10l1-1.997h2V17.9a5.001 5.001 0 01-2.992-1.889H4V4.033h16z' />
    <path d='M15 16.011V16h-1a3 3 0 01-3-3v-3a3 3 0 013-3 1 1 0 110 2 1 1 0 00-1 1v3a1 1 0 001 1h4a1 1 0 001-1v-3a1 1 0 00-1-1 1 1 0 110-2c.768 0 1.47.289 2 .764.614.55 1 1.347 1 2.236v3c0 .889-.386 1.687-1 2.236A2.989 2.989 0 0118 16h-1v2.007A1 1 0 0018 19h.268a2 2 0 110 2H18a3 3 0 01-3-2.993M15 18v-1.989V18z' />
  </svg>
)

export default SvgHealthSystemOutline
